import { Box, styled } from '@mui/material';

export const Content = styled(Box)`
  background: #1d1f21;
  flex-grow: 1;
  position: relative;
`;
